import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { summaryPackages } from "@redotech/redo-fulfillment-group-common/shipment-summary";
import { formatSentenceCase } from "@redotech/util/string";

export const DeliveryStatusCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Delivery status",
    cell: (row) => {
      const status = summaryPackages(row.shipmentSummary)[0]?.trackingStatus;
      return status ? formatSentenceCase(status) : "";
    },
  };
